<template>
  <div class="boss-container">
    <div class="inner-width">
      <div class="time-limit">
        {{ minSec.min }}:{{ minSec.sec }}
      </div>      
      <!-- inner-width -->
      <div class="boss-zone">
        <div class="HP-box">
          <h1 class="label">HP:</h1>
          <span class="bar">
            <span class="boss" :style="bossPer"></span>
          </span>
          <p>{{ bossHP }}/10000</p>                    
        </div>            
        <img src="@/assets/devil.png" alt="">   
      </div>
      <!-- inner-width -->
      <div class="terminal-title">
        <p>"Terminal"</p>      
      </div>      
      <!-- inner-width -->
      <div class="terminal-wrapper">
        <div class="terminal">
            <div v-for="(log, index) in logs" :key="index">
                <p><span>$</span>{{ log.input }}</p>
                <p>{{ log.output }}</p>
            </div>            
            <label for="input">{{ current }}$</label>
            <input 
              type="text" 
              id="input"   
              autocomplete="off"   
              v-on:keydown.enter="enterKey"
              v-on:keyup.ctrl.76="refresh"
              v-model="terminal"            
            >
        </div>
      </div>         
      <!-- inner-width -->   
    </div> 
  </div>
</template>
<script>
import { db } from '@/firebase'
// data, computed, created, methods ...
export default {
  data: function() {
    return {      
      timeLimit: 300,
      terminal: "",
      current: "you", 
      logs: [],     
      bossHP: 10000,
      userDir: {                 
        attack: {
          sord: 5,
          beat: 2,
          gun: 6,
          stone: 1,
        },      
        bag: {
          poteto: "HP+10",
          kimuchi: "HP+2",
          medicine: "HP+200",        
        }     
      },      
    };
  },
  computed: {
    user(){
      return this.$store.getters.user
    },       
    bossPer(){
      return{
        '--width': String(Math.floor(this.bossHP / 100)) + "%"
      }
    },
    minSec(){
      const min = Math.floor(this.timeLimit / 60)
      let sec = this.timeLimit % 60
      sec += ""      
      if(sec.length == 1){        
        sec = "0" + sec
      }
      return{
        sec:sec,
        min: "0" + min
      }
    },  
  },
  mounted(){        
    setInterval(() => { this.timeLimit-- }, 1000)
  },
  watch: {
    timeLimit: function(val) {
      if (val <= 0) {       
        this.lose()         
      }
    }  
  },        
  methods: {   
    enterKey() {
      const commandList = this.terminal.split(' ')
      const command = commandList[0]
      const option = commandList[1]  
      if(commandList[2] != undefined){
        const output = command + ": too many arguments"
        this.pushLogs(output)    
        return    
      } else {
        switch(command){
          case "ls":
            this.ls(this.terminal)
            break   
          case "attack": 
            this.attack(option)  
            break
          case "cd":  
            this.cd(option)
            break    
          case "hack":{
            this.addItem(option)
            break
          }      
          case "use":{
            this.use(option)
            break 
          }      
          default:{
            const output = "command not found: " + this.terminal
            this.pushLogs(output)
          }
        }    
      }            
    },
    ls() {    
      switch(this.current){
        case "bag":{
          const output = "poteto kimuchi medicine"     
          this.pushLogs(output) 
          break           
        }
        case "attack":{      
          const output = Object.keys(this.userDir.attack).join(' ')
          this.pushLogs(output)            
          break
        }
        default:{ // userDir
          const output = "attack bag"     
          this.pushLogs(output)             
        }
      }              
    },
    cd: function (dirname) {      
      switch(dirname){
        case "..": 
          this.current = "you"  
          this.pushLogs()             
          break
        case "bag": 
        case "attack":      
          if(this.current == "you"){
            this.current = dirname
            this.pushLogs() 
            break
          } else{
            const output = "cd: no such file or directory: " + dirname  
            this.pushLogs(output)           
            break            
          }        
        default: {
          const output = "cd: no such file or directory: " + dirname  
          this.pushLogs(output)           
          break
        }        
      }        
    },
    attack(item) {           
      if(this.current == "attack"){ 
        if(item == undefined){
          this.pushLogs("usage: attack technique ...")
          return
        }         
        const damagePower = this.userDir.attack[item] 
        if (damagePower){
          this.damage(damagePower)           
          this.pushLogs("You attacked to the boss with " + item)
        } else{          
          this.pushLogs("You don't have that " + item)          
        }
      } else {        
        this.pushLogs("in this directory, You can not attack")
      } 
    },
    use(item){
      if(this.current == "bag"){
        switch(item){
          case "poteto": 
            this.pushLogs("You eat poteto HP+10")
            break
          case  "kimuchi": 
            this.pushLogs("You eat kimuchi HP+2")
            break
          case "medicine":  
            this.pushLogs("You eat kimuchi HP+2")
            break
          default: 
            this.pushLogs("you don't have that")
        } 
      }else {        
        this.pushLogs("in this directory are not nothing to use")
      } 
    },
    pushLogs: function (output) {
      this.logs.push({
        input: this.terminal,        
        output: output
      })         
      this.terminal = ""    
    },      
    refresh: function () {
      this.logs = []
    },
    damage(power){          
      this.bossHP -= power
      if(this.bossHP <= 0){
        this.bossHP = 0
        setTimeout(this.win, 2100);
      }               
    },
    addItem(ops){
      if(this.current == "attack"){
        if(ops == undefined){
          this.pushLogs("usage: hack ItemName:Integer")          
        } else {
          const itemObj = ops.split(":")
          if(Number(itemObj[1])){
            const itemName = itemObj[0]
            const num = Number(itemObj[1])    
            this.userDir.attack[itemName] = num
            this.pushLogs()        
          } else {
            this.pushLogs("usage: hack ItemName:Integer")  
          }                        
        }        
      } else {
        const output = "in only attack dir, you can add a item"
        this.pushLogs(output)
      }
    },
    win(){  
      db.collection('users').doc(this.user.uid).update({
        win:true,     
        winTime: new Date()
      })
      alert("You win")
      this.$router.push('/')
    },
    lose(){
      alert("You lose...")
      this.$router.push('/')
    }, 
  },  
}
</script>

<style lang="scss" scoped>
// .HP-box , 
// .terminal-wrapper 
// -- are under in this --
.boss-container{
  width: 100%;
  min-height: 100vh;
  background: rgb(24, 26, 27);
  // background-image: url("../assets/_.jpeg");
  background-size: cover; 
  text-align: center;
  position: relative;  
  padding-top: 24px;
  .inner-width{ // for boss-container
    width: 800px;
    margin: auto; 
    .time-limit{
      // background-color: rgba(255, 255, 255, 0.3);
      background-image: url("../assets/GIPHY.gif");
      // background-size: cover; 
      padding: 8px;
      font-size: 28px;
      color:#00ff1e;  
    }  
    .boss-zone{
      // background-color: rgba(255, 255, 255, 0.3);
      img{
        height: 200px;
      }
    } 
    .terminal-title{
      padding: 60px 0 16px 0;
      p{
        font-size: 28px;
      }
    }    
  }
}
.terminal-wrapper{
  width: 500px;
  height: 300px;
  overflow: auto;
  padding: 4px;
  margin: auto;
  background: black;
  text-align: left;
  border: 1px solid white;
  border-radius: 4px;
  .terminal {
    width: 100%;
    label{
      color:#01dfd9;
    }
    #input{
      // width: 100%;
      background: none;
      color: white; 
      outline: 0;
      border: none;
      font-weight: 300;
      font-size: 20px; 
    }
  }
} 
.HP-box{
  display: inline-block;    
  .label, .bar{
    display: inline-block;
  }
  .bar{
    width: 100px;  
    height: 6px;  
    margin-bottom: 7px;   
    background: #353b48;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 3px;
    box-shadow: 0 0 10px  #2187e7b3;
    overflow: hidden;    
    span{      
      height: 6px;      
      float: left;
      background: #2187e7;
    }
    .boss{
      --width: 100%;
      width: var(--width);
      transition-duration: 2s;
    }
  }
}

</style>